export const arrayOfUnion =
  <T>() =>
  <U extends T[]>(array: U & ([T] extends [U[number]] ? unknown : never)) =>
    array;
